@if (item?.errors) {
  <div class="error-box">
    @for (error of item.errors; track error) {
      <div class="error-messages">
        @switch (error) {
          @case ('Alias') {
            <div class="error-message">Duplicate Alias {{item.Alias}}</div>
          }
        }
      </div>
    }
  </div>
}